"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sign = exports.removeSignature = exports.denyUnlessSigned = exports.signingH = exports.signedData = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var signatureKey = 'snabbdom_signature';
var signature = Symbol.for(signatureKey);

var signedData = _defineProperty({}, signatureKey, signature);

exports.signedData = signedData;

var signData = function signData(data) {
  return Object.assign({}, data, signedData);
};

var isPlainTextNode = function isPlainTextNode(vnode) {
  return vnode.children === undefined && vnode.data === undefined && vnode.key === undefined;
};

var isSigned = function isSigned(vnode) {
  return vnode.data ? vnode.data[signatureKey] === signature : isPlainTextNode(vnode);
};

var removeSignatureFromData = function removeSignatureFromData(data) {
  return Object.assign({}, data, _defineProperty({}, signatureKey, undefined));
};

var isPrimitive = function isPrimitive(a) {
  return ['string', 'number'].includes(_typeof(a));
};

var signingH = function signingH(defaultH) {
  return function (sel, b, c) {
    if (c !== undefined) {
      // a - sel, b - data, c - primitive/child/children
      return defaultH(sel, signData(b), c);
    } else if (b === undefined) {
      // a - sel
      return defaultH(sel, signedData);
    } else if (Array.isArray(b) || b.sel || isPrimitive(b)) {
      // a - sel, b - primitive/child/children
      return defaultH(sel, signedData, b);
    } else {
      // a - sel, b - data
      return defaultH(sel, signData(b));
    }
  };
};

exports.signingH = signingH;

var denyUnlessSignedHook = function denyUnlessSignedHook(oldVnode, vnode) {
  if (!isSigned(vnode)) {
    throw new Error('Patching with a vnode which is not correctly signed!');
  }
};

var denyUnlessSigned = {
  create: denyUnlessSignedHook,
  update: denyUnlessSignedHook
};
exports.denyUnlessSigned = denyUnlessSigned;

var processDataRecursively = function processDataRecursively(checkIfValidVnode, dataProcessFn) {
  var fn = function fn(tree) {
    checkIfValidVnode(tree);
    var data = dataProcessFn(tree.data);
    var children = tree.children ? tree.children.map(fn) : undefined;
    return Object.assign({}, tree, {
      data: data,
      children: children
    });
  };

  return fn;
};

var removeSignature = processDataRecursively(function (vnode) {
  if (!isSigned(vnode)) {
    throw new Error('Unable to remove the signature, because the vnode is not signed.');
  }
}, removeSignatureFromData);
exports.removeSignature = removeSignature;
var sign = processDataRecursively(function () {}, signData);
exports.sign = sign;